import React from "react";
import { StripeProvider } from "react-stripe-elements";
import { Row, Col, Card, Divider, Collapse, Icon } from "antd";

import Checkout from "./Checkout";
import SubscriptionDetail from "./SubscriptionDetail";
import PayPlanCard from "../common/PayPlanCard";

const { Panel } = Collapse;

const Payment = props => {
  return (
    <div style={{ marginTop: 30 }}>
      <Row style={{ marginTop: 30 }}>
        <Col span={6}>
          <h3>Billing</h3>
        </Col>
        <Col span={16} offset={2}>
          <Row style={{ marginBottom: 20, textAlign: "center" }} gutter={16}>
            <Col span={8}>
              <PayPlanCard
                onClickPlan={() => props.onClickPlan("starter")}
                onChangePlan={() => props.onChangePlan("starter")}
                title="Starter"
                price="$9.99"
                detail="1000 Recipients"
                bgc="#4cb992"
                state={props.state}
                plan="Starter"
                checked={props.checked}
                subscription={props.subscription}
              />
            </Col>
            <Col span={8}>
              <PayPlanCard
                onClickPlan={() => props.onClickPlan("pro")}
                onChangePlan={() => props.onChangePlan("pro")}
                title="Pro"
                price="$15.00"
                detail="2000 Recipients"
                bgc="#3499E0"
                state={props.state}
                plan="Pro"
                checked={props.checked}
                subscription={props.subscription}
              />
            </Col>
            <Col span={8}>
              <PayPlanCard
                onClickPlan={() => props.onClickPlan("store")}
                onChangePlan={() => props.onChangePlan("store")}
                title="Store"
                price="$19.99"
                detail="3000 Recipients"
                bgc="#EA9D53"
                state={props.state}
                plan="Store"
                checked={props.checked}
                subscription={props.subscription}
              />
            </Col>
          </Row>

          {props.subscription[0] && props.subscription[0].subscribed === false ? (
            <Card style={{ marginBottom: 10 }}>
              <StripeProvider apiKey="pk_test_r36Z2sJHOIOiiJWxsewyW9Vf">
                <Checkout {...props} />
              </StripeProvider>
            </Card>
          ) : null}
        </Col>
      </Row>
      <Divider />
      {props.subscription.length &&
      props.subscription.cancel_at_period_end &&
      props.subscription.status === "active" ? (
        <div>
          <Row style={{ marginTop: 30 }}>
            <Col span={6}>
              <h3>Card</h3>
            </Col>
            <Row style={{ marginBottom: 20 }} gutter={16}>
              <Col style={{ marginLeft: 80 }} span={8}>
                <Collapse
                  bordered={false}
                  defaultActiveKey={["0"]}
                  expandIcon={({ isActive }) => (
                    <Icon type="caret-right" rotate={isActive ? 90 : 0} />
                  )}
                >
                  <Panel
                    style={{ border: 0, overflow: "hidden" }}
                    header="Update Credit Card"
                    key="1"
                  >
                    <p>
                      {props.subscription.length && props.subscription[0].brand}{" "}
                      card ending in{" "}
                      {props.subscription.length && props.subscription[0].last4}
                    </p>

                    <StripeProvider apiKey="pk_test_r36Z2sJHOIOiiJWxsewyW9Vf">
                      <Checkout {...props} />
                    </StripeProvider>
                  </Panel>
                </Collapse>
              </Col>
            </Row>
          </Row>
          <Divider />
        </div>
      ) : null}
      {props.subscription.length &&
        props.subscription.map((sub, index) => (
          <SubscriptionDetail
            key={index}
            subscription={sub}
            cancelSubscription={props.cancelSubscription}
          />
        ))}
    </div>
  );
};

export default Payment;
